import React, { Component } from "react";
//import react in our code.
import { StyleSheet, View, SectionList, TextInput } from "react-native";
import { FlatList } from "react-native-gesture-handler";
import { Constant, MyCart } from "./Data.js";
import {
  Container,
  Header,
  Button,
  Content,
  List,
  ListItem,
  Left,
  Body,
  Right,
  Thumbnail,
  Text,
  Title,
  Footer,
  Icon,
  Input,
} from "native-base";
import * as firebase from "firebase";
import "firebase/firestore";
import { DeleteOutlined } from "@ant-design/icons";
import { HeaderBackButton } from "@react-navigation/stack";

import { TipModal } from "./TipModal.js";

export default class CartScreen extends Component {
  constructor(props) {
    //constructor to set default state

    super(props);
    // console.log(this.props.myCart);

    this.state = {
      menuArray: [],
      myCart: MyCart.shared.getCartItems(),
      tipModal: null,
      tipPercentage: 0,
    };
    this.props.navigation.addListener("focus", () => {
      const items = MyCart.shared.getCartItems();
      this.setState({ myCart: items });
    });
  }

  deleteFromCart = (itemKey) => {
    const newState = this.state;
    const index = newState.myCart.findIndex((a) => a.key === itemKey);

    if (index === -1) return;
    newState.myCart.splice(index, 1);

    // MyCart.shared.setMenuArray(newState.myCart);
    this.setState(newState); // This will update the state and trigger a rerender of the components
  };

  giveTipButtonTapped = () => {
    if (this.tipModal) {
      this.tipModal.openModal();
    }
  };

  onTipSelected = (tipPercentage) => {
    this.setState({ tipPercentage: tipPercentage });
  };

  getTotalTotal(tipPercentage) {
    let subTotal = MyCart.shared.getCartSubTotal();
    let tax = MyCart.shared.getCartTaxesFees();
    let tipAmount = tipPercentage * subTotal;
    let totalTotal = tipAmount + subTotal + tax;
    return totalTotal.toFixed(2);
  }
  getSubTotal(tipPercentage) {
    let subTotal = MyCart.shared.getCartSubTotal();
    return subTotal.toFixed(2);
  }
  getTipTotal(tipPercentage) {
    let subTotal = MyCart.shared.getCartSubTotal();
    let tipAmount = tipPercentage * subTotal;
    return tipAmount.toFixed(2);
  }

  checkoutButtonTapped = () => {
    if (this.state.myCart.length === 0) {
      this.props.navigation.navigate("Payment");
      return;
    } else {
      const totalAmount = this.getTotalTotal(this.state.tipPercentage);
      const subTotalAmount = MyCart.shared.getCartSubTotal();
      const tipAmount = this.getTipTotal(this.state.tipPercentage);
      this.props.navigation.navigate("Payment", {
        stripeID: this.props.route.params.stripeID,
        name: this.props.route.params.name,
        restaurantID: this.props.route.params.restaurantID,
        tableID: this.props.route.params.tableID,
        totalAmount: totalAmount,
        subTotalAmount: subTotalAmount,
        tipAmount: tipAmount,
        myCart: this.state.myCart,
      });
      // this.props.navigation.navigate("Payment", {
      //   stripeID: "sid",
      //   name: "Flyby Diner XX",
      //   restaurantID: "Tid",
      //   tableID: "Tid",
      //   totalTotal: totalTotal,
      // });
    }
  };

  render() {
    return (
      <View
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          backgroundColor: Constant.backgroundColor,
        }}
      >
        <TipModal
          ref={(ref) => {
            this.tipModal = ref;
          }}
          onTipSelected={this.onTipSelected}
        />
        <SectionList
          sections={[{ title: "Items", data: this.state.myCart }]}
          keyExtractor={(item, index) => item + index}
          renderItem={({ item }) => (
            <CartItemElement
              item={item}
              onClickFunction={() => this.deleteFromCart(item.key)}
            />
          )}
          renderSectionHeader={({ section: { title } }) => (
            <ListItem>
              <Text
                style={{
                  fontFamily: Constant.font,
                  fontWeight: "600",
                  fontSize: 20,
                }}
              >
                {title}
              </Text>
            </ListItem>
          )}
        />

        <View>
          <View>
            <ListItem>
              <Text
                style={{
                  fontFamily: Constant.font,
                  fontWeight: "600",
                  fontSize: 20,
                }}
              >
                Total
              </Text>
            </ListItem>

            <ListItem noBorder>
              <Left>
                <Text
                  style={{
                    fontFamily: Constant.font,
                    fontSize: 16,
                  }}
                >
                  Subtotal
                </Text>
              </Left>

              <Right>
                <Text
                  style={{
                    fontFamily: Constant.font,
                    fontSize: 16,
                  }}
                >
                  ${MyCart.shared.getCartSubTotal()}
                </Text>
              </Right>
            </ListItem>

            <ListItem noBorder>
              <Left>
                <Text
                  style={{
                    fontFamily: Constant.font,
                    fontWeight: "400",
                    fontSize: 16,
                  }}
                >
                  Taxes
                </Text>
              </Left>

              <Right>
                <Text
                  style={{
                    fontFamily: Constant.font,
                    fontWeight: "400",
                    fontSize: 16,
                  }}
                >
                  ${MyCart.shared.getCartTaxesFees()}
                </Text>
              </Right>
            </ListItem>

            <TipElement
              tipPercentage={this.state.tipPercentage}
              tipButton={() => this.giveTipButtonTapped()}
            />

            <ListItem noBorder>
              <Button
                style={styles.checkoutButton}
                onPress={() => this.checkoutButtonTapped()}
              >
                <View
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Text
                    style={{
                      fontWeight: "600",
                      fontSize: 18,
                      fontFamily: Constant.font,
                      color: "#fff",
                    }}
                  >
                    Pay Now
                  </Text>
                  <Text
                    style={{
                      fontWeight: "600",
                      fontSize: 18,
                      fontFamily: Constant.font,
                      color: "#fff",
                    }}
                  >
                    ${this.getTotalTotal(this.state.tipPercentage)}
                  </Text>
                </View>
              </Button>
            </ListItem>
          </View>
        </View>
      </View>
    );
  }
}
const styles = StyleSheet.create({
  checkoutButton: {
    alignItems: "center",
    fontWeight: "bold",
    backgroundColor: Constant.color1,
    borderRadius: 12,
    height: 60,
    width: "100%",
  },
});

function TipElement(props) {
  console.log("JJJKKK", props.tipAmount);
  const tipPercentage = props.tipPercentage;
  const tipAmount = (MyCart.shared.getCartSubTotal() * tipPercentage).toFixed(
    2
  );
  const tipButton = props.tipButton;

  var element = (
    <View
      style={{
        marginLeft: 16,
        marginRight: 16,
      }}
    >
      <Button
        style={{
          alignItems: "center",
          fontWeight: "bold",
          backgroundColor: Constant.gray,
          borderRadius: 10,
          height: 44,
          width: "100%",
        }}
        onPress={tipButton}
      >
        <View
          style={{
            flex: 1,
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              fontWeight: "500",
              fontSize: 16,
              fontFamily: Constant.font,
              color: "black",
            }}
          >
            Add a tip
          </Text>
        </View>
      </Button>
    </View>
  );

  if (tipPercentage !== 0) {
    element = (
      <ListItem noBorder>
        <Left>
          <Text
            style={{
              fontFamily: Constant.font,
              fontWeight: "400",
              fontSize: 16,
            }}
          >
            Tip
          </Text>
        </Left>

        <Right>
          <Text
            style={{
              fontFamily: Constant.font,
              fontWeight: "400",
              fontSize: 16,
            }}
          >
            ${tipAmount}
          </Text>
        </Right>
      </ListItem>
    );
  }

  return element;
}

function CartItemElement(props) {
  const item = props.item;
  const onClickFunction = props.onClickFunction;

  var mainElement;
  if (item.comment === "") {
    mainElement = (
      <Body>
        <Text
          style={{
            fontFamily: Constant.font,
            fontWeight: "500",
            fontSize: 16,
          }}
        >
          {item.title}
        </Text>
      </Body>
    );
  } else {
    mainElement = (
      <Body>
        <Text
          style={{
            fontFamily: Constant.font,
            fontWeight: "500",
            fontSize: 16,
          }}
        >
          {item.title}
        </Text>
        <Text
          style={{
            fontFamily: Constant.font,
            fontWeight: "400",
            fontSize: 16,
            color: "gray",
            marginTop: 4,
          }}
        >
          {item.comment}
        </Text>
      </Body>
    );
  }

  return (
    <ListItem noBorder Thumbnail>
      {mainElement}
      <Right>
        <Text
          style={{
            fontFamily: Constant.font,
            fontWeight: "500",
            fontSize: 16,
          }}
        >
          ${item.price}
        </Text>
      </Right>

      <Right>
        <DeleteOutlined onClick={onClickFunction} />
      </Right>
    </ListItem>
  );
}
